<template>
  <div class="installation-container tab-body flex-column h-100 urlinstaller-container">
    <div class="custom-tab-body-cont px-2 py-3">
      <b-row>
        <b-col class="p-4 mx-4" style="    padding-left: 60px !important;">
          <b-form-group id="exampleInputGroup1" label="Enter URL" label-for="exampleInput1">
            <b-form-input id="exampleInput1" type="text" v-model="url" placeholder="http://">
            </b-form-input>
          </b-form-group>
          <b-form-group id="exampleGroup4">
            <b-form-checkbox v-model="addToFavorites" @click="setFocus">Add to favorites</b-form-checkbox>
          </b-form-group>
          <b-form-group v-if="addToFavorites" id="fav_plugin_name_label" label="Plugin Name" label-for="exampleInput1">
            <b-form-input id="fav_plugin_name" ref="favoritename" type="text" v-model="pluginName" placeholder="">
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col></b-col>
      </b-row>
    </div>
    <div class="custom-tab-body-footer">
      <div class="d-flex align-items-center flex-row-reverse">
          <div><b-button variant="primary" @click="install" :disabled="$v.url.$invalid||$v.sites.$invalid">Install</b-button></div>
          <div class="mr-3"><b-form-checkbox v-model="clearDestination" class="installoptions">Overwrite if {{this.type=='plugins'?'plugin':'theme'}} exist</b-form-checkbox></div>
          <div class="mr-3"><b-form-checkbox v-model="activate" class="installoptions">Activate after installation</b-form-checkbox></div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
export default {
  name: 'urlinstaller',
  props: ['sites', 'type'],
  data() {
    return {
      addToFavorites: false,
      pluginName: '',
      url: '',
      clearDestination: false,
      activate: false
    };
  },
  mixins: [validationMixin],
  validations: {
    url: {
      required
    },
    sites: {
      required
    }
  },
  watch: {
    addToFavorites(newVal) {
      if (newVal) {
        this.setFocus();
      }
    }
  },
  methods: {
    prependHttpIfNecessary() {
      let url = this.url.toLowerCase();
      if (!url.startsWith('http')) {
        this.url = `http://${this.url}`;
      }
    },
    install() {
      this.prependHttpIfNecessary();
      let eventPayload = {
        selectedItems: [this.url],
        type: this.type,
        clearDestination: this.clearDestination,
        activate: this.activate
      };
      if (this.addToFavorites) {
        eventPayload.addFavourites = {
          name: this.pluginName,
          URL: this.url,
          type: this.type
        };
      }
      this.$emit('onInstall', eventPayload);
    },
    setFocus() {
      setTimeout(() => {
        this.$refs.favoritename.focus();
      }, 100);
    }
  }
};
</script>

<style scoped>
.updates-tab-body>>>.tab-content {
  overflow: hidden;
}
.tab-body>>>.updates-tab-body-cont {
  overflow: auto;
  height: 263px;
}
</style>
